import { z } from 'zod';
/**
 * Hợp đồng API của module `org` — Giám đốc tạo / đổi tên / xoá phòng ban và nhóm.
 *
 * Schema cố ý lỏng (xem chú thích ở `users.ts`): loại đơn vị sai, mã sai, tên quá ngắn… do
 * service xét và trả câu báo tiếng Việt của hệ thống cũ.
 */
export const orgUnitParamsSchema = z.object({ id: z.string().max(64) });
export const createOrgUnitRequestSchema = z.object({
    id: z.string().max(64).default(''),
    /** 'department' | 'team'. */
    kind: z.string().max(32).default(''),
    name: z.string().max(200).default(''),
    /** Bắt buộc với `team` (id của phòng chứa nó); với `department` thì bị bỏ qua. */
    parentId: z.string().max(64).nullable().default(null),
});
export const renameOrgUnitRequestSchema = z.object({
    name: z.string().max(200).default(''),
});
//# sourceMappingURL=org.js.map